const initialState = [
    {
      id: 1,
      title: "Boost your conversion rate",
      category: "FUN",
      img: "https://images.unsplash.com/photo-1496128858413-b36217c2ce36?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80",
      author_name: "Learn with sumit",
      author_img: "https://avatars.githubusercontent.com/u/73503432?v=4",
      create_at: "11 Jul, 2022",
      read_time: 6,
    },
    {
      id: 2,
      title: "How to use search engine optimization to drive sales",
      category: "SEO",
      img: "https://images.unsplash.com/photo-1547586696-ea22b4d4235d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80",
      author_name: "Arif Almas",
      author_img: "https://icon-library.com/images/icon-programmer/icon-programmer-14.jpg",
      create_at: "8 Jul, 2022",
      read_time: 4,
    },
    {
      id: 3,
      title: "Improve your customer experience",
      category: "SELLS",
      img: "https://images.unsplash.com/photo-1547586696-ea22b4d4235d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80",
      author_name: "Arif Almas",
      author_img: "https://icon-library.com/images/icon-programmer/icon-programmer-14.jpg",
      create_at: "8 Jul, 2022",
      read_time: 7,
    },
    {
      id: 4,
      title: "Boost your conversion rate",
      category: "SELLS",
      img: "https://images.unsplash.com/photo-1496128858413-b36217c2ce36?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80",
      author_name: "Learn with sumit",
      author_img: "https://avatars.githubusercontent.com/u/73503432?v=4",
      create_at: "2 Jul, 2022",
      read_time: 10,
    },
    {
      id: 5,
      title: "How to use search engine optimization to drive sales",
      category: "FUN",
      img: "https://images.unsplash.com/photo-1547586696-ea22b4d4235d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80",
      author_name: "Learn with sumit",
      author_img: "https://avatars.githubusercontent.com/u/73503432?v=4",
      create_at: "2 Jul, 2022",
      read_time: 10,
    },
    {
      id: 6,
      title: "Improve your customer experience",
      category: "SELLS",
      img: "https://images.unsplash.com/photo-1492724441997-5dc865305da7?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80",
      author_name: "Arif Almas",
      author_img: "https://icon-library.com/images/icon-programmer/icon-programmer-14.jpg",
      create_at: "20 Jul, 2022",
      read_time: 10,
    },
  ];
  
  export default initialState;
  